export const iconFontAwesomeNatureMountain = (
	<i className="fa-solid fa-mountain"></i>
);
